import { DateTime } from 'luxon';
import React, { HTMLProps, useMemo, useState } from 'react';
import {
    MonthlyReturnRate,
    useGetModelPortfoliosMonthlyReturns,
} from '../../../../api/funds-robot/getModelPortfolioMonthlyReturns';
import { Portfolio } from '../../../../types/Portfolio';
import { toPercentage } from '../../../../utils/parsers';
import { titleRow } from './NavOverlayTablesData';

export const MonthlyReturn: React.FC<{ portfolio?: Portfolio } & HTMLProps<HTMLDivElement>> = ({
    className,
    portfolio,
}) => {
    const [coordinate, setCoordinate] = useState({
        x: -1,
        y: -1,
    });

    const portfolioReturns = useGetModelPortfoliosMonthlyReturns(
        portfolio?.id,
        DateTime.now().minus({ year: 10 }),
        DateTime.now(),
    );

    const monthlyReturnData = useMemo(() => {
        return createMonthlyReturnData(portfolioReturns.data?.monthlyReturnRates || []);
    }, [portfolioReturns.data]);

    return (
        <div className={`flex flex-1 justify-left items-center m-4 text-xs lg:w-auto overflow-x-scroll ${className}`}>
            <table
                className="flex-1"
                onMouseLeave={() => {
                    setCoordinate({
                        x: -1,
                        y: -1,
                    });
                }}
            >
                <tbody>
                    <tr>
                        {titleRow.map((columnName, index) => {
                            return (
                                <td className="p-0" key={index}>
                                    <div
                                        className={`flex justify-center items-center py-6 ${
                                            columnName === 'Jaar' ? 'font-medium' : ''
                                        }`}
                                        key={`{${columnName} {${index}`}
                                    >
                                        {columnName}
                                    </div>
                                </td>
                            );
                        })}
                    </tr>
                    {monthlyReturnData.map((yearData, rowIndex) => {
                        return (
                            <tr key={rowIndex}>
                                <td className="pr-2 p-0">
                                    <div className="flex justify-center items-center py-4">{yearData.year}</div>
                                </td>
                                {yearData.returns.map((returnRate, columnIndex) => {
                                    return (
                                        <td className="p-0 m-0" key={columnIndex}>
                                            <div
                                                className={`border-l border-t border-gray-500 flex justify-center items-center py-4 w-20 lg:w-auto  ${
                                                    coordinate.y === rowIndex && coordinate.x === columnIndex
                                                        ? 'bg-bnd-yellow/80'
                                                        : coordinate.y === rowIndex
                                                        ? 'bg-bnd-yellow/40'
                                                        : coordinate.x === columnIndex
                                                        ? 'bg-bnd-yellow/40'
                                                        : ''
                                                } ${
                                                    columnIndex + 1 === yearData.returns.length
                                                        ? 'border-r font-medium bg-gray-300'
                                                        : ''
                                                }
                        ${rowIndex + 1 === monthlyReturnData.length ? 'border-b' : ''}`}
                                                onMouseEnter={() => {
                                                    // setColumnNumber(columnIndex);
                                                    // setRowNumber(rowIndex);
                                                    setCoordinate({
                                                        x: columnIndex,
                                                        y: rowIndex,
                                                    });
                                                }}
                                            >
                                                {returnRate === -100 ? '-' : toPercentage(returnRate)}
                                            </div>
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

const createMonthlyReturnData = (returnRates: MonthlyReturnRate[]) => {
    const years = createLastTenYearsArray();
    const months = createMonthsArray();
    let yearSum = 1;
    let monthValue = 0;
    const returndata = years.map((year) => {
        yearSum = 1;
        const returnMonthData = months.map((month) => {
            if (month === 13) {
                return (yearSum - 1) * 100;
            } else {
                let monthRate = returnRates.filter(
                    (rate) => DateTime.fromISO(rate.date).month === month && DateTime.fromISO(rate.date).year === year,
                );
                if (monthRate.length > 0) {
                    monthValue = monthRate[0].return * 100;
                    yearSum = yearSum * (1 + monthValue / 100);
                } else {
                    monthValue = -100; //impossible value
                }
                return monthValue;
            }
        });
        return { year: year.toString(), returns: returnMonthData };
    });

    return returndata;
};

const createLastTenYearsArray = () => {
    const endYear = DateTime.now().year;
    let startYear = endYear - 10;
    let years: number[] = [];

    while (startYear <= endYear) {
        years = years.concat(startYear);
        startYear = startYear + 1;
    }

    return years;
};

const createMonthsArray = () => {
    let array: number[] = [];
    for (let i = 1; i <= 13; i++) {
        array = array.concat(i);
    }
    return array;
};
